const getEnvValue = (env = import.meta.env, key) => env?.[key] || '';

const getVersionValue = ({ env = import.meta.env } = {}) => {
  const version = getEnvValue(env, 'VITE_APP_VERSION') || __APP_VERSION__ || 'dev';
  return version.trim() || 'dev';
};

export const getAppVersion = ({ env = import.meta.env } = {}) => getVersionValue({ env });

export const getAppBuildId = ({ env = import.meta.env } = {}) => {
  const buildId = getEnvValue(env, 'VITE_APP_BUILD_ID') || __APP_BUILD_ID__ || '';
  return buildId.trim();
};

export const getAppVersionLabel = ({ env = import.meta.env } = {}) => {
  const version = getAppVersion({ env });
  const buildId = getAppBuildId({ env });

  if (!buildId) {
    return `v${version}`;
  }

  return `v${version} • ${buildId}`;
};

export const getAppVersionInfo = ({ env = import.meta.env } = {}) => ({
  version: getAppVersion({ env }),
  buildId: getAppBuildId({ env }),
  label: getAppVersionLabel({ env }),
});
